module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": "flat"
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "400",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalAnular()
      }
    },
    model: {
      value: (_vm.isModalCancelarCita),
      callback: function($$v) {
        _vm.isModalCancelarCita = $$v
      },
      expression: "isModalCancelarCita"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-4"
  }, [_vm._v("¿Estas seguro que deseas cancelar la cita?")]), _c('div', {
    staticClass: "pa-4"
  }, [_c('v-textarea', {
    ref: "comentarioParaCancelar",
    attrs: {
      "hide-details": "hide-details",
      "autofocus": "autofocus",
      "placeholder": "Describe un motivo por el cual deseas cancelar la cita",
      "color": "primary",
      "solo": "solo",
      "dense": "dense",
      "rows": "8"
    },
    model: {
      value: (_vm.comentarioParaCancelar),
      callback: function($$v) {
        _vm.comentarioParaCancelar = $$v
      },
      expression: "comentarioParaCancelar"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalCancelarCita()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarCita()
      }
    }
  }, [_vm._v("Cancelar cita")])], 1)], 1)], 1), _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [(_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "font-size-15"
  }, [(!_vm.id) ? _c('div', {
    staticClass: "d-flex jc-center fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Nueva programación " + _vm._s(_vm.fechaPicker))]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Programa ahora y luego podras visualizarlo en el modulo principal")])]) : _c('div', {
    staticClass: "d-flex jc-center fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Editando programacion  de cita" + _vm._s(("#" + _vm.id)))]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("Verifica bien los cambios antes de reprogramar")])])]), _c('v-spacer'), _c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [(_vm.id) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "animated fadeInUp faster",
          attrs: {
            "icon": "icon",
            "dark": "dark"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v(" more_vert")])], 1) : _vm._e()]
      }
    }])
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "disabled": _vm.cita.ingresadoAtaller === 1
    },
    on: {
      "click": function($event) {
        return _vm.openModalCancelarCita()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Eliminar esta programación")])], 1), (_vm.noEstaEnAgenda) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.goTo(("/programacion/citas/" + (_vm.cita.id)))
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Visualizar cita en agenda")])], 1) : _vm._e()], 1)], 1)], 1), (!_vm.isLoading) ? _c('div', {
    staticClass: "pa-4"
  }, [(_vm.cita.ingresadoAtaller) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('v-alert', {
    staticClass: "flex-1 mb-2",
    attrs: {
      "border": "left",
      "color": "success",
      "dark": "",
      "outlined": "outlined",
      "icon": "check_circle",
      "dense": "dense"
    }
  }, [_c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Esta cita ya fue cerrada por que el equipo ya ingreso a taller")])])], 1) : _vm._e(), (_vm.cita.numeroTicket && !_vm.noEstaEnAgenda) ? _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "color": "secondary primary--text",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/ticket/' + _vm.cita.numeroTicket)
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("visibility")]), _vm._v("ver detalles de ticket")], 1) : _vm._e(), (_vm.cita.numeroTicket) ? _c('v-card', {
    key: "ticketSeleccionada",
    staticClass: "elevation-1 mb-4"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', [_c('v-chip', {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.cita.ingresadoAtaller ? 'success' : 'orange',
      "label": "label",
      "small": "small",
      "text-color": "white"
    }
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-11",
    domProps: {
      "innerHTML": _vm._s(_vm.cita.numeroTicket)
    }
  })]), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
    staticClass: "font-weight-700 font-size-14"
  }, [_vm._v(_vm._s(_vm.cita.titulo))])]), (_vm.cita.fechaRegistro) ? _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("fué creado hace " + _vm._s(_vm._f("now")(_vm.cita.fechaRegistro)))]) : _c('v-list-item-subtitle', {
    staticClass: "grey--text font-size-11"
  }, [_vm._v("En proceso de creación")])], 1), (!_vm.noEstaEnAgenda && !_vm.cita.ingresadoAtaller) ? _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": _vm.clearTicketSeleccionado
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _c('span', [_vm._v("Cambiar")])], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), (!_vm.cita.numeroTicket) ? _c('listado-tickets-seleccionar', {
    staticClass: "mb-6",
    attrs: {
      "toCita": true,
      "numero": _vm.cita.numeroTicket
    },
    on: {
      "selected": _vm.obtenerTicketSeleccionado
    }
  }) : _vm._e(), (_vm.fechaPicker) ? _c('div', {
    staticClass: "d-flex mb-3"
  }, [_c('small', {
    staticClass: "primary--text font-size-11"
  }, [_vm._v("*Los puntos de color en el calendario hacen referencia a las fechas festivas.*")])]) : _vm._e(), (_vm.fechaPicker) ? _c('v-date-picker', {
    attrs: {
      "events": _vm.arrayEvents,
      "full-width": "full-width",
      "landscape": false,
      "no-title": "no-title",
      "color": "primary",
      "disabled": _vm.cita.ingresadoAtaller === 1,
      "event-color": "primary"
    },
    on: {
      "change": function($event) {
        return _vm.verificarFechaYObtenerHoras()
      }
    },
    model: {
      value: (_vm.fechaPicker),
      callback: function($$v) {
        _vm.fechaPicker = $$v
      },
      expression: "fechaPicker"
    }
  }) : _vm._e(), (_vm.fechaPicker) ? _c('v-select', {
    attrs: {
      "disabled": !_vm.horas.length || _vm.cita.ingresadoAtaller === 1,
      "item-text": "hora",
      "items": _vm.horas,
      "label": "Horas disponibles para la fecha seleccionada",
      "dense": "dense",
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.cita.horaCita),
      callback: function($$v) {
        _vm.$set(_vm.cita, "horaCita", $$v)
      },
      expression: "cita.horaCita"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex mt-2"
  }, [(!_vm.cita.ingresadoAtaller) ? _c('v-btn', {
    attrs: {
      "block": _vm.isMovil,
      "small": !_vm.isMovil,
      "block": "block",
      "color": "success",
      "disabled": !_vm.cita.numeroTicket || !_vm.fechaPicker || !_vm.cita.horaCita
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCita()
      }
    }
  }, [(_vm.id) ? _c('span', [_vm._v("reprogramar cita")]) : _c('span', [_vm._v("generar cita")])]) : _vm._e()], 1)], 1) : _c('div', [_c('div', {
    staticClass: "pa-4"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-three-line"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a25650","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_form_programacion_cita.vue
// module id = 478
// module chunks = 1